// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"e6749515","977":"0e2e2a96"}[chunkId] + ".chunk.js";
};